module.exports = __webpack_public_path__ + "static/gray-2f4d784b20c8b29cce8421f7d36c6b32.png";